module.exports = __webpack_public_path__ + "img/class2.e2c5f9d1.png";